import React, { useState } from "react";
import Navbar from "../components/mainNavBar";
import HomeFooter from "../components/homefooter";
import { Helmet } from "react-helmet";
import { howItWorks } from "../assets/data/metaData";
import { useNavigate } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { faqs } from "../assets/data/faqs";

export default function Howtouse() {
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <Helmet>
        <title>{howItWorks.title} </title>
        <meta
          name="description"
          content={howItWorks.description}
          data-rh="true"
        />
        <meta
          name="og:description"
          content={howItWorks.description}
          data-rh="true"
        />
        <meta name="keywords" content={howItWorks.keywords} data-rh="true" />
        <meta property="og:title" content={howItWorks.title} data-rh="true" />
        <meta property="og:image" content={howItWorks.image} data-rh="true" />
        <meta property="og:url" content={howItWorks.url} data-rh="true" />
        <meta
          property="og:publisher"
          content={howItWorks.publisher}
          data-rh="true"
        />
        <meta property="og:author " content={howItWorks.author} data-rh="true" />
        <meta
          property="og:site_name"
          content={howItWorks.site_name}
          data-rh="true"
        />
        <meta property="og:locale" content={howItWorks.locale} data-rh="true" />
        <meta property="og:type" content={howItWorks.type} data-rh="true" />
        <link rel="canonical" href={howItWorks.canonical} data-rh="true" />
      </Helmet>
      <Navbar />
      <main className="pagebg">
        <section className="hero">
          <div className="hero-text">
            <h1>Statistical Rigor Meets Unparalleled Data Depth</h1>
            <p>
              Our approach combines proven research methodologies with the most
              comprehensive consumer profiles available, and unmatched speed to
              insight
            </p>
          </div>
          <div className="hero-image">
            <img
              className="img-responsive"
              alt="Generative Insight Research"
              src="/json-media/img/howto/howtoUsebanner.webp"
              width="800px"
            />
          </div>
        </section>
        <section className="researcher-tools" style={{ padding: "15PX" }}>
          <h3>The Fastest Path from Questions to Insights</h3>
          <p>
            Provide enterprise-grade insights to your organization, on any
            topic,
            <br /> in a matter of hours
          </p>
          <br />
          <div className="web-view-only">
            <img
              className="img-responsive"
              src={"/json-media/img/howto/midimg.webp"}
            />
          </div>
          <div className="mobile-view">
            <img
              className="img-responsive"
              src={"/json-media/img/howto/midimgmobile.webp"}
              width={300}
            />
          </div>
        </section>
        <section className="section unlock-insights">
          <div className="unlock-content">
            <div className="unlock-text">
              <div className="hero-buttons">
                <div>
                  <button
                    className="primary-btn"
                    onClick={() => navigate("/create-survey")}
                  >
                    Get Started Today
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="insights-solution ">
          <div className="howto-feature">
            <div className="content">
              <h3>
                Comprehensive Banner <br /> Books
              </h3>
              <p>
                Compare each segment’s responses to each
                <br /> survey question, augmented with statistical significance
                <br /> testing and color coding
              </p>
            </div>
            <div>
              <img
                className="img-responsive"
                alt="Complementary Toolkit"
                src="/json-media/img/howto/ComprehensiveBanner.webp"
              />
            </div>
          </div>
        </section>
        <br />
        <section className="insights-solution ">
          <div className="howto-feature">
            <div>
              <img
                className="img-responsive"
                alt="Complementary Toolkit"
                src="/json-media/img/howto/ResearchFindings.webp"
              />
            </div>
            <div className="content">
              <h3>Research Findings Report</h3>
              <p>
                Professional report summarizing key findings,including
                <br /> data exhibits and supporting insights
              </p>
            </div>
          </div>
        </section>
        <br />
        <section className="insights-solution ">
          <div className="howto-feature">
            <div className="content">
              <h3>Interactive Segment Avatars</h3>
              <p>
                Continue the conversation with interactive AI
                <br /> avatars representing each strategic segment
              </p>
            </div>
            <div>
              <img
                className="img-responsive"
                alt="Complementary Toolkit"
                src="/json-media/img/howto/InteractiveSegment.webp"
              />
            </div>
          </div>
        </section>
        <br />
        <section className="section unlock-insights insights-solution ">
          <section className="researcher-tools" style={{ padding: "15PX" }}>
            <h3>Ready to Add AI to Your Research Toolkit?</h3>
            <p>
              Partner with Al to accelerate your research. Book a live demo or
              start your project instantly.
            </p>
          </section>
          <div className="unlock-content">
            <div className="unlock-text">
              <div className="hero-buttons">
                <div>
                  <button
                    className="primary-btn"
                    onClick={() => navigate("/create-survey")}
                  >
                    Start Your First Project
                  </button>
                </div>
                {/* <div>
                  <button className="secondary-btn">
                    View Sample Deliverables
                  </button>
                </div> */}
              </div>
              <br />
            </div>
          </div>
        </section>
        <br />
        <section className="faq-section">
          <h2 className="faq-title">
            Frequently Asked Questions?
          </h2>
          <p className="faq-subtitle">
            We are excited to introduce you to the future of
            <br />
            consumer insights!
          </p>

          <div className="faq-container">
            {faqs.map((item, index) => (
              <div className="faq-item" key={index}>
                <button className="faq-question" onClick={() => toggle(index)}>
                  {item.q}
                  <ExpandMoreIcon
                    className={`faq-arrow ${openIndex === index ? "open" : ""}`}
                  />
                </button>
                {openIndex === index && (
                  <div className="faq-answer">
                    <p>{item.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>
      </main>
      <HomeFooter />
    </>
  );
}
